import { Loki } from "./loki";
import { Collection } from "./collection";

Loki["Collection"] = Collection;

export {Loki, Collection};
export default Loki;
